import { useEffect } from "react"
import getCenter from "@turf/center-of-mass"
import type { MapRef } from "react-map-gl/mapbox"
import { getIGNParcelFromCoordinates } from "@/lib/explore/api/geo"
import type { IParcel } from "@/types/explore"

interface UseInitialLoadProps {
  code_insee?: string
  center?: [number, number]
  onSelectCommune: (code: string) => Promise<void>
  mapRef: React.RefObject<MapRef | null>
  setSelectedParcels: React.Dispatch<React.SetStateAction<IParcel[]>>
  setParcelPOI: (poi: { lon: number | null; lat: number | null }) => void
}

export const useInitialLoad = (props: UseInitialLoadProps) => {
  const { code_insee, center, onSelectCommune, mapRef, setSelectedParcels, setParcelPOI } = props

  useEffect(() => {
    const loadInitialData = async () => {
      if (!code_insee && !center) return

      if (code_insee) {
        await onSelectCommune(code_insee)
      }

      if (center) {
        try {
          const [lon, lat] = center
          const parcel = await getIGNParcelFromCoordinates([lon, lat])
          if (parcel) {
            const parcelleCenter = getCenter(parcel?.geometry)
            setSelectedParcels([{ ...parcel, center: parcelleCenter?.geometry?.coordinates as [number, number] }])
            setParcelPOI({ lon, lat })

            if (mapRef.current && parcelleCenter?.geometry?.coordinates) {
              mapRef.current.flyTo({
                center: parcelleCenter.geometry.coordinates as [number, number],
                zoom: 18,
                duration: 2000,
              })
            }
          }
        } catch (error) {
          console.error("Erreur lors du chargement de la parcelle:", error)
        }
      }
    }

    loadInitialData()
  }, [code_insee, center])
}
